export enum RouteType {
  GENERAL = 'GENERAL',
  ACCOUNT = 'ACCOUNT',
  ORGANIZATION = 'ORGANIZATION',
}
